import React from 'react';

// White edge fade over the right side of a sideways-scrolling box
const ScrollFadeV2: React.FC<{ visible: boolean; className?: string }> = ({
  visible,
  className = '',
}) => (
  <div
    className={`absolute top-0 right-0 h-full w-20 bg-gradient-to-l from-white to-transparent pointer-events-none transition-opacity duration-300 ${
      visible ? 'opacity-100' : 'opacity-0'
    } ${className}`}
  />
);

export default ScrollFadeV2;
